import { useAppEnvironmentContext } from '../contexts/appEnvironmentContext';
import { useOfficeContext } from './addin/office';

// Suggested by GitHub Copilot
export const isMacOS = () => {
  return /Mac|iPod|iPhone|iPad/.test(navigator.userAgent);
};

export const useAppPlatform = (): 'web' | 'excel' | 'powerpoint' => {
  const { isExcel } = useOfficeContext();
  const { appEnvironment } = useAppEnvironmentContext();
  return appEnvironment === 'web' ? 'web' : isExcel ? 'excel' : 'powerpoint';
};
